export const environment = {
	production: false,
	apiHost: 'https://seoreportapi.spericorn.com/',
	STRIPE_KEY:'pk_test_51PnIzyFGMXZlQoJ8VpcqwGZFw9Wk49ZWPdfjP9f6ho2mTvexO06Tz3PRz5vO9wQjqE0mCw3xonva7uBdQd7nbY1u00D5LItSaX'
};

